
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/purchase-order-follow-up",
      function () {
        return require("private-next-pages/ai/purchase-order-follow-up.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/purchase-order-follow-up"])
      });
    }
  